import { Maniless } from '@wsb/guac-widget-core';

const { constants: { routes } } = Maniless;

export const BASE = routes.BASE;
export const EVENT = '/events/$';
